import React, { Component } from "react";
import {
  Header,
  Segment,
  Input,
  Button,
  Progress,
  Transition
} from "semantic-ui-react";

class DocumentUploader extends Component {
  state = { file: null };

  handleChangeUpload = e => this.setState({ file: e.target.files[0] });

  handleUploadFile = () => this.props.handleUploadFile(this.state.file);

  render() {
    return (
      <React.Fragment>
        <Input
          transparent
          type="file"
          onChange={this.handleChangeUpload}
          accept=".jpg, .jpeg, .png, .pdf, .txt"
        />
        <Button
          content="Adjuntar Fichero"
          color="pink"
          disabled={this.state.file === null}
          onClick={this.handleUploadFile}
        />
        <Segment basic>
          <Transition.Group animation="fade" duration={600}>
            {this.props.uploadComplete && (
              <Header>{this.props.uploadComplete}</Header>
            )}
            {this.props.procesoEnvio > 0 && (
              <Progress
                percent={this.props.procesoEnvio}
                indicating
                size="tiny"
              />
            )}
          </Transition.Group>
        </Segment>
      </React.Fragment>
    );
  }
}
export default DocumentUploader;



// WEBPACK FOOTER //
// ./src/pages/adjuntarDocumentacion/DocumentUploader.jsx